import {
  type BooleanValue,
  type DecimalValue,
  DescriptionValue,
  type NumberValue,
  type SelectChoice,
  type SelectValue,
  type TextValue,
} from '@snap-types/models/auto-configurator/state';
import type { Decimal } from '@snap-types/types/decimal';
import { Nullish } from '@snap-types/types/nullish';

import { FALSE_VALUE_STRING, TRUE_VALUE_STRING } from '../../constants';

export function buildDecimalValue(
  value: Decimal | null = null,
  rawValue = '',
): DecimalValue {
  if (!rawValue) {
    rawValue = value ? value.toString() : '';
  }

  return {
    type: 'decimal',
    value,
    rawValue,
    isValid: true,
    hasParseError: false,
    isDirty: false,
    isTouched: false,
    isLoading: false,
    errors: [],
  };
}

export function buildNumberValue(
  value: number | null = null,
  rawValue = '',
): NumberValue {
  if (!rawValue) {
    rawValue = value ? value.toString() : '';
  }

  return {
    type: 'number',
    value,
    rawValue,
    isValid: true,
    hasParseError: false,
    isDirty: false,
    isTouched: false,
    isLoading: false,
    errors: [],
  };
}

export function buildSelectValue(
  selectChoice: Nullish<SelectChoice> = null,
  rawValue = '',
): SelectValue {
  if (!rawValue) {
    rawValue = selectChoice ? selectChoice.value.toString() : '';
  }

  return {
    type: 'select',
    value: selectChoice,
    rawValue,
    isValid: true,
    hasParseError: false,
    isDirty: false,
    isTouched: false,
    isLoading: false,
    errors: [],
  };
}

export function buildTextValue(
  value: string | null = null,
  rawValue = '',
): TextValue {
  if (!rawValue) {
    rawValue = value ? value.toString() : '';
  }

  return {
    type: 'text',
    value,
    rawValue,
    isValid: true,
    hasParseError: false,
    isDirty: false,
    isTouched: false,
    isLoading: false,
    errors: [],
  };
}

export function buildDescriptionValue(
  value: string | null = null,
  rawValue = '',
): DescriptionValue {
  if (!rawValue) {
    rawValue = value ? value.toString() : '';
  }

  return {
    type: 'description',
    value,
    rawValue,
    isValid: true,
    hasParseError: false,
    isDirty: false,
    isTouched: false,
    isLoading: false,
    errors: [],
  };
}

export function buildBooleanValue(
  value: boolean | null = false,
  rawValue:
    | typeof TRUE_VALUE_STRING
    | typeof FALSE_VALUE_STRING = FALSE_VALUE_STRING,
): BooleanValue {
  if (value === null) {
    return {
      type: 'boolean',
      value: false,
      rawValue,
      isValid: true,
      hasParseError: false,
      isDirty: false,
      isTouched: false,
      isLoading: false,
      errors: [],
    };
  }

  return {
    type: 'boolean',
    value,
    rawValue,
    isValid: true,
    hasParseError: false,
    isDirty: false,
    isTouched: false,
    isLoading: false,
    errors: [],
  };
}
